"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _pageCache = require("@/utils/pageCache");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppMain',
  data: function data() {
    return {
      cacheAccessOrder: [(0, _pageCache.getPageKey)(this.$route)]
    };
  },
  computed: {
    cacheEpoch: function cacheEpoch() {
      return this.$store.state.tagsView.cacheEpoch;
    },
    cacheNames: function cacheNames() {
      var _this = this;
      if (this.$store.state.app.device === 'mobile' || !this.$store.state.settings.tagsView) return [];
      // Old noCache form routes keep their drafts. Only explicitly disposable
      // pages are subject to the small LRU budget.
      return (0, _pageCache.selectCachedViews)(this.$store.state.tagsView.visitedViews, this.$route, this.cacheAccessOrder).map(function (v) {
        return _this.nameFor(v);
      });
    },
    hostKey: function hostKey() {
      return this.nameFor(this.$route);
    }
  },
  watch: {
    $route: function $route(to, from) {
      var _this2 = this;
      this.scrollPositions[(0, _pageCache.getPageKey)(from)] = this.$el.scrollTop;
      var key = (0, _pageCache.getPageKey)(to);
      this.cacheAccessOrder = this.cacheAccessOrder.filter(function (item) {
        return item !== key;
      }).concat(key);
      this.$nextTick(function () {
        _this2.$el.scrollTop = _this2.scrollPositions[key] || 0;
        _this2.pruneHosts();
      });
    },
    cacheNames: function cacheNames() {
      this.pruneHosts();
    }
  },
  created: function created() {
    this.hosts = Object.create(null);
    this.scrollPositions = Object.create(null);
  },
  methods: {
    pruneHosts: function pruneHosts() {
      var _this3 = this;
      var names = this.cacheNames;
      Object.keys(this.hosts).forEach(function (key) {
        if (names.indexOf(key) === -1 && key !== _this3.hostKey) delete _this3.hosts[key];
      });
      var keys = this.$store.state.tagsView.visitedViews.map(_pageCache.getPageKey);
      var accessOrder = this.cacheAccessOrder.filter(function (key) {
        return keys.indexOf(key) !== -1 || key === (0, _pageCache.getPageKey)(_this3.$route);
      });
      if (accessOrder.length !== this.cacheAccessOrder.length) this.cacheAccessOrder = accessOrder;
      Object.keys(this.scrollPositions).forEach(function (key) {
        if (keys.indexOf(key) === -1) delete _this3.scrollPositions[key];
      });
    },
    resolveHost: function resolveHost(key) {
      if (!this.hosts[key]) this.hosts[key] = (0, _pageCache.createPageHost)(_vue.default, key);
      return this.hosts[key];
    },
    nameFor: function nameFor(route) {
      var version = this.$store.state.tagsView.cacheVersions[(0, _pageCache.getPageKey)(route)] || 0;
      return (0, _pageCache.getCacheName)(route) + '_e' + this.cacheEpoch + '_v' + version;
    }
  }
};